import {fetchJSON} from "../../utils/dataAccess";

export function loadCompaniesForSelect(valueProperty = 'id') {
  return dispatch => {
    dispatch(loading(true));
    fetchJSON('/companies/select?sort[name]=asc').then((companies) => {
      dispatch(companiesLoaded(companies['hydra:member'].map(
        function (company) {
          return {
            value: company[valueProperty],
            text: company.name,
          }
        }
      )));
      dispatch(loading(false));
    }).catch(e => {
      dispatch(loading(false));
      dispatch(error(e.message));
    })
  };
}

export function loading(loading) {
  return {type: 'COMPANIES_FOR_SELECT_LOADING', loading};
}

export function error(error) {
  return {type: 'COMPANIES_FOR_SELECT_ERROR', error};
}

export function companiesLoaded(retrieved) {
  return {type: 'COMPANIES_FOR_SELECT_RETRIEVED', retrieved};
}
